import { Button, Form, Modal } from 'antd';
import React from 'react';
import SetStripeCustomerForm from './SetStripeCustomerForm';
import { setStripeCustomer } from 'src/apis/Reporting/SetStripeCustomer';

interface ILocalProps {
    companyProfileID: number;
    customerName: string;
    handleClose: () => void;
    handleSubmit: () => void;
}

interface ILocalState {
    loading: boolean;
    responseMessage: string;
}

class SetStripeCustomerModal extends React.Component<ILocalProps, ILocalState> {
    public state = { loading: false, responseMessage: '' };

    public formReference: Form | null = null;

    public handleSubmit = () => {
        const { companyProfileID } = this.props;
        if (this.formReference !== null && this.formReference.props.form) {
            this.formReference.props.form.validateFields({ force: true }, async (err, values) => {
                if (err) {
                    const message = err.toString() === '[object Object]' ? '' : err.toString();
                    this.setState({ responseMessage: message, loading: false });
                    return;
                }
                this.setState({ loading: true });

                const response = await setStripeCustomer(
                    companyProfileID,
                    values.stripeCustomerID,
                    values.stripeRegion
                );

                this.setState({ responseMessage: response.message, loading: false });
                if (response.success) {
                    this.props.handleSubmit();
                }
            });
        }
    };

    public saveFormRef = (formReference: Form) => {
        this.formReference = formReference;
    };

    public render() {
        const title = 'Set Stripe Customer for ' + this.props.customerName;
        return (
            <Modal
                closable={false}
                title={title}
                visible={true}
                className="modal"
                footer={[
                    <Button key="close" onClick={this.props.handleClose} style={{ float: 'left' }}>Close</Button>,
                    <Button key="submit" loading={this.state.loading} onClick={this.handleSubmit} type="primary">Submit</Button>,
                ]}
            >
                <SetStripeCustomerForm
                    wrappedComponentRef={this.saveFormRef}
                />
                <span className="errorMessage">{this.state.responseMessage}</span>
            </Modal>
        );
    }
}

export default SetStripeCustomerModal;
